export default {"src":"/_next/static/media/EHACare-BarIcon.459ec999.svg","height":109,"width":121};